/** Drill-down for a single AI interview session (`/ai-interviews/:sessionId?tab=`). */
export const AI_INTERVIEW_SESSION_TABS = ['review', 'candidate', 'email', 'calendar', 'ai-interviews', 'parameters'] as const;
export type AiInterviewSessionTabId = (typeof AI_INTERVIEW_SESSION_TABS)[number];

export function parseAiInterviewSessionTab(raw: string | null): AiInterviewSessionTabId | null {
  if (raw && (AI_INTERVIEW_SESSION_TABS as readonly string[]).includes(raw)) {
    return raw as AiInterviewSessionTabId;
  }
  return null;
}
